//énuméré des cultures, au sens général, connues et reconnues :
export const enumCultureGlobal = {
    unknown: 0,
    ble: 1,
    orge: 2,
    colza: 3,
    mais: 4,
    ble_dur: 5,
    pois_printemps: 6,
    pomme_terre: 7,
}


//énuméré permettant la gestion d'un conseil Azoté (Equivalent à 'AvailableCropEnum' côté C#) !
export const enumCultureFertilizer = {
    unknown: 0,
    ble_hiver: 1,
    orge_hiver: 2,
    colza_hiver: 3,
    ble_dur_hiver: 4,
}

export const enumCultureHarvest = {
    None: 0,
    Corn: 1
}

export const enumCultureModelisation = {
    ble_hiver: 2,
    colza: 3,
    mais: 5,
    orge: 6,
    escourgon: 7,
    pois_printemps: 9,
    pomme_terre: 10
} 


/**
 * Fonction permettant dans le cas ou l'enumeré de parcel provient d'un conseil azoté, 
 * de le convertir en enuméré global afin d'éviter de modifier l'ensemble du code.
 * 
 * A utiliser uniquement dans le cas de la fertilization afin d'éviter d'éventuel bug
 * @param {*} enumFerti 
 * @returns 
 */
export const EnumFertiToEnumGlobal = (enumFerti) => {
    switch (enumFerti) {
        case enumCultureFertilizer.ble_hiver:
            return enumCultureGlobal.ble;
        case enumCultureFertilizer.orge_hiver:
            return enumCultureGlobal.orge;
        case enumCultureFertilizer.colza_hiver:
            return enumCultureGlobal.colza;
        case enumCultureFertilizer.ble_dur_hiver:
            return enumCultureGlobal.ble_dur;
        default:
            return enumCultureGlobal.unknown;
    }
}

/**
 * Fonction permettant dans le cas ou l'enuméré de parcel provient de la modélisation, de le convertir en enuméré global. 
 * Car actuellement le cropType provient de la table modelisationCrop
 * @param {*} enumModelisation
 * @returns
 */
export const EnumModelisationToEnumGlobal = (enumModelisation) => {
    switch (enumModelisation) {
        case enumCultureModelisation.ble_hiver:
            return enumCultureGlobal.ble;
        case enumCultureModelisation.colza:
            return enumCultureGlobal.colza;
        case enumCultureModelisation.mais:
            return enumCultureGlobal.mais;
        case enumCultureModelisation.orge:
            return enumCultureGlobal.orge;
        case enumCultureModelisation.escourgeon:
            return enumCultureGlobal.orge;
        case enumCultureModelisation.pois_printemps:
            return enumCultureGlobal.pois_printemps;
        case enumCultureModelisation.pomme_terre:
            return enumCultureGlobal.pomme_terre;
        default:
            return enumCultureGlobal.unknown;
    }
}